import { useQuery } from 'react-query'

import axiosInstance from 'api/axiosInstance'
import { type Referral } from 'api/types/referrals'
import { type Response } from 'api/types/Response'

export type ReferralRole = 'creator' | 'fan'

export const useReferrals = (role: ReferralRole) => {
    const getReferralData = async () => {
        const { data: res } =
            await axiosInstance.get<Response<Referral[]>>(
                '/api/user/referral',
                {
                    params: {
                        role
                    }
                }
            )

        return res.data
    }

    return useQuery(
        ['referrals-list', role],
        getReferralData,
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false
        }
    )
}